import { styled, IconButton } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const Button = styled(IconButton)(() => ({
  marginLeft: 'auto',
}));
